import {Component, ViewChild} from "@angular/core";
import {Validators, FormGroup, FormControl} from "@angular/forms";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DartAPIService} from "./dart.service";
import {SuccessComponent} from "../errors/success.component";
import {handleErrors} from "../misc/handle-errors.decorator";
import {toggleLoading} from "../misc/loading.decorator";

export type DartDealImportDialogModel = {
  projectId: string;
};

@Component({
  templateUrl: "./dartDealImport-dialog.template.pug",
  providers: [DartAPIService],
})
export class DartDealImportDialogComponent extends DialogComponent<DartDealImportDialogModel, boolean>
  implements DartDealImportDialogModel {
  @ViewChild(SuccessComponent)
  public successComponent;

  public projectId: string;
  public error: Error;
  public processing: boolean = false;

  public importDealForm = new FormGroup({
    dartDealKey: new FormControl("", [Validators.required, Validators.pattern("^[1-9][0-9]*\\.[0-9]*$")]),
  });

  constructor(
    public dialogService: DialogService,
    public dartApiService: DartAPIService,
  ) {
    super(dialogService);
    this.result = false;
  }

  @toggleLoading("processing")
  @handleErrors()
  async importDealKey() {
    this.processing = true;
    this.result = false;
    this.successComponent.closeAll();

    await this.dartApiService.importDartDealById(this.importDealForm.controls["dartDealKey"].value, this.projectId);
    this.result = true;
    this.successComponent.showSuccessMessage("DART Deal(s) imported.");
  }
}
